module.exports = __webpack_public_path__ + "img/velans-sub-features-2.7031863.jpg";